/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PointsCollectedTodayCategoryDataDto
 */
export interface PointsCollectedTodayCategoryDataDto {
    /**
     * 카테고리
     * @type {string}
     * @memberof PointsCollectedTodayCategoryDataDto
     */
    'category': PointsCollectedTodayCategoryDataDtoCategoryEnum;
    /**
     * 카테고리별 오늘 모은 포인트
     * @type {number}
     * @memberof PointsCollectedTodayCategoryDataDto
     */
    'pointsCollectedToday': number;
}

export const PointsCollectedTodayCategoryDataDtoCategoryEnum = {
    Click: 'click',
    Install: 'install',
    Post: 'post',
    Etc: 'etc',
    Auto: 'auto',
    Plus: 'plus',
    Supporters: 'supporters',
    Guardian: 'guardian',
    Admin: 'admin',
    System: 'system'
} as const;

export type PointsCollectedTodayCategoryDataDtoCategoryEnum = typeof PointsCollectedTodayCategoryDataDtoCategoryEnum[keyof typeof PointsCollectedTodayCategoryDataDtoCategoryEnum];


